import React, { Component } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { produce } from 'immer'
import { RootState } from '../../store'
import { undoHistory, redoHistory } from '../../views/LabelBuilder/LabelBuilder.slice'
import Icon from '../Icon'
import Badge from './Badge'
import { i18n } from "../../i18n/i18n";
interface Props {}

type CombinedProps = Props & ConnectedProps<typeof connector>

class History extends Component<CombinedProps> {
  baseClass = 'flex items-center gap-1 select-none'

  get undo () {
    const { canUndo, undoHistory } = this.props
    const className = canUndo ? 'cursor-pointer' : 'cursor-not-allowed text-secondary'
    const iconColor = canUndo ? 'dark' : 'gray'
    return (
      <div
        className={`${this.baseClass} ${className}`}
        onClick={undoHistory}>
        <Icon
          name='arrow-go-back'
          size="extraSmall"
          color={iconColor} />
        <span className='text-xxs'>{i18n("Undo")}</span>
      </div>
    )
  }

  get redo () {
    const { canRedo, redoHistory } = this.props
    const className = canRedo ? 'cursor-pointer' : 'cursor-not-allowed text-secondary'
    const iconColor = canRedo ? 'dark' : 'gray'
    return (
      <div
        className={`${this.baseClass} ${className}`}
        onClick={redoHistory}>
        <span className='text-xxs'>{i18n("Redo")}</span>
        <Icon
          name='arrow-go-forward'
          size="extraSmall"
          color={iconColor} />
      </div>
    )
  }

  render () {
    return (
      <Badge>
        {this.undo}
        {this.redo}
      </Badge>
    )
  }
}

function mapStateToProps (state: RootState) {
  const { labelBuilder } = produce(state, draft => draft)
  const { history } = labelBuilder
  const { pointer, stack } = history
  const canUndo = pointer !== null && pointer !== 0
  const canRedo = pointer !== null && pointer !== stack.length - 1
  return { canUndo, canRedo }
}

const mapDispatchToProps = {
  undoHistory,
  redoHistory
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(History)
